'use strict';

let HL = HL || {};
let UTILS = UTILS || {};
let static_folder = '/images';
let googleMapLoaded = false;

HL.utils = UTILS || {};
HL.owl = {};


HL.utils.inputLabels = function inputLabels() {
    function placeholderPolyfill(el) {
      this.classList[this.value ? 'add' : 'remove']('filled');
    }

    if ( document.querySelector('input') ) {
        var allInputs = document.querySelectorAll('input');
        var allTextareas = document.querySelectorAll('textarea');
        var allSelects = document.querySelectorAll('select');

        [].forEach.call(allInputs, function(singleInput) {
            singleInput.classList[singleInput.value ? 'add' : 'remove']('filled');
            singleInput.addEventListener('change', placeholderPolyfill);
            singleInput.addEventListener('keyup', placeholderPolyfill);
        });

        [].forEach.call(allTextareas, function(singleTextarea) {
            singleTextarea.classList[singleTextarea.value ? 'add' : 'remove']('filled');
            singleTextarea.addEventListener('change', placeholderPolyfill);
            singleTextarea.addEventListener('keyup', placeholderPolyfill);
        });

        [].forEach.call(allSelects, function(singleSelect) {
            singleSelect.classList[singleSelect.value ? 'add' : 'remove']('filled');
            singleSelect.addEventListener('change', placeholderPolyfill);
        });
    }
};

HL.utils.showHide = function showHide(obj, id) {
    let allInputs = document.querySelector(`#${id}`).querySelectorAll('input');

    if (obj.checked === true) {
        $(document.querySelector(`#${id}`)).show();

        [].forEach.call(allInputs, function(singleInput) {
            singleInput.setAttribute('required', true);
        });

    } else {
        $(document.querySelector(`#${id}`)).hide();

        [].forEach.call(allInputs, function(singleInput) {
            singleInput.removeAttribute('required');
        });
    }
};

HL.navigation = {
    showMegamenu: function() {
        if ( document.querySelector('.js-burger') ) {

            var burgerButtons = document.querySelectorAll('.js-burger'),
                megamenu = document.querySelector('.js-megamenu'),
                MEGAMENU_OPEN_CLASS_NAME = 'megamenu--open';

            [].forEach.call(burgerButtons, function(burgerButton) {
                burgerButton.addEventListener("click", function( event ) {
                    event.preventDefault();

                    if (document.body.classList.contains('open')) {
                        document.body.classList.remove('open');
                        burgerButton.classList.remove('l-burger--open');
                        megamenu.classList.remove(MEGAMENU_OPEN_CLASS_NAME);
                    } else {
                        document.body.classList.add('open');
                        burgerButton.classList.add('l-burger--open');
                        megamenu.classList.add(MEGAMENU_OPEN_CLASS_NAME);
                    }
                });
            });
        }
    },

    closeMegamenu: function() {
        if ( document.querySelector('.js-megamenu-close') ) {
            var burgerButton = document.querySelector('.js-megamenu-close');

            burgerButton.addEventListener("click", function( event ) {
                event.preventDefault();
                HL.navigation.__removeMegamenuOpenClass();
                document.body.classList.remove('open');
            });
        }
    },

    __removeMegamenuOpenClass: function() {
        var megamenu = document.querySelector('.js-megamenu'),
            MEGAMENU_OPEN_CLASS_NAME = 'megamenu--open';

        document.body.classList.remove('open');
        document.querySelector('.js-burger').classList.remove('l-burger--open');
        megamenu.classList.remove(MEGAMENU_OPEN_CLASS_NAME);

    },

    closeMegamenuByHitEsc: function() {
        document.addEventListener('keyup', function( event ) {
            if (event.keyCode === 27) {
                HL.navigation.__removeMegamenuOpenClass();
                if ( document.querySelector('.js-overlay') ){

                    document.querySelector('.js-overlay').classList.remove('overlay--show');
                }
            }
        });
    },

    position: $(window).scrollTop(),

    navbarPosition: function() {
        var scroll;

        if ( document.querySelector('.js-navbar-scroll') ) {
            scroll = window.scrollY  || window.pageYOffset  || document.documentElement.scrollTop;

            if (scroll > 300) {

                if (scroll > HL.navigation.position) {
                    document.querySelector('.js-navbar-scroll').classList.remove('l-navbar--scroll');
                } else {
                    document.querySelector('.js-navbar-scroll').classList.add('l-navbar--scroll');
                }

                document.querySelector('.js-navbar-scroll').classList.remove('l-navbar--on-top');
                document.querySelector('.js-navbar-scroll').classList.add('l-navbar--moved');
            } else {
                document.querySelector('.js-navbar-scroll').classList.add('l-navbar--scroll');
                document.querySelector('.js-navbar-scroll').classList.add('l-navbar--on-top');
                document.querySelector('.js-navbar-scroll').classList.remove('l-navbar--moved');
            }

            HL.navigation.position = scroll;
        }
    },

    toggleSubMenu: function() {
        let subMenuButtons = $('.js-dropdown');

        subMenuButtons.on('click', function() {
            let sumMenu = $(this).next();
            sumMenu.slideToggle();
        });

    },

    init: function() {
        this.showMegamenu();
        this.closeMegamenu();
        this.closeMegamenuByHitEsc();
        this.toggleSubMenu();
    }
};

HL.instagramFeed = {
    loadInstagramFeedComponent: function(selector) {
        let loadingPlaceholder = selector.querySelector('.js-loading-placeholder');

        HL.utils.loadScript('https://apps.elfsight.com/p/platform.js', () => {
            if (loadingPlaceholder) {
                setTimeout(() => {
                    selector.removeChild(loadingPlaceholder);
                }, 0);
            }
        });
    },
    init: function() {
        const feedSelector = document.getElementById('js-instagram-feed');

        if (!feedSelector) {
            return;
        }

        let waypoint = new Waypoint({
            element: feedSelector,
            handler: (direction) => {
                this.loadInstagramFeedComponent(feedSelector);
            },
            offset: '100%'
        });
    }
};

HL.owl.process = function process() {
    let owlProcessSlider = $('.js-owl-process');

    if (owlProcessSlider.length) {
        owlProcessSlider.each(function() {
            var self = this,
                owl = $(self);

            const owlSettings = {
                stagePadding: 0,
                loop: true,
                dots: true,
                dotsContainer: owl.parent().find('.owl-progress'),
                margin: 24,
                nav: false,
                center: false,
                lazyLoad: false,
                responsive: {
                    0: {
                        items: 1.3,
                    },
                    768: {
                        items: 2.3,
                    },
                }
            };

            owl.owlCarousel(owlSettings);

            owl.parent().find('.owl-prev').click(function() {
                owl.trigger('prev.owl.carousel', [300]);
                return false;
            });

            owl.parent().find('.owl-next').click(function() {
                owl.trigger('next.owl.carousel', [300]);
                return false;
            });

            owl.on('changed.owl.carousel',
                function() {
                    HL.refreshLazyLoading();
                }
            );
        });
    };
};

HL.owl.gallery = function gallery() {
    const owlSettings = {
        stagePadding: 50,
        loop: true,
        dots: true,
        margin: 10,
        nav: false,
        center:true,
        lazyLoad: true,

        responsive:{
            0:{
                items:1,
                stagePadding: 80
            },

            600:{
                items:1,
                stagePadding: 120
            },
            1000:{
                items:1,
                stagePadding: 220
            },

            1400:{
                items:1,
                stagePadding: 320
            },


            1700:{
                items:1,
                stagePadding: 420
            },

            2500:{
                items:1,
                stagePadding: 600
            }
        }
    };

    let owlGallerySlider = $('.js-owl-gallery');

    if ( owlGallerySlider.length ) {
        owlGallerySlider.each(function(index) {
            var self = this,
                owl = $(self);
            owl.owlCarousel(owlSettings);
            $( '<a href="" class="owl-prev" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="17.969" height="18" viewBox="0 0 17.969 18"><path d="M370.171,3702.36l8.612,8.64,0.715-.72-7.749-7.77h16.265v-1.02H371.749l7.749-7.77-0.715-.72-8.612,8.64A0.511,0.511,0,0,0,370.171,3702.36Z" transform="translate(-370.031 -3693)"/></svg></a>' ).insertBefore( owl.find('.owl-dots') );
            $( '<a href="" class="owl-next" type="button"><svg xmlns="http://www.w3.org/2000/svg" width="17.968" height="18" viewBox="0 0 17.968 18"><path d="M630.861,3701.64l-8.6-8.64-0.713.72,7.735,7.77H613.049v1.02h16.236l-7.735,7.77,0.713,0.72,8.6-8.64A0.512,0.512,0,0,0,630.861,3701.64Z" transform="translate(-613.063 -3693)"/></svg></a>' ).insertAfter( owl.find('.owl-dots') );

            owl.find('.owl-prev').click(function() {
                owl.trigger('prev.owl.carousel', [300]);
                return false;
            });

            owl.find('.owl-next').click(function() {
                owl.trigger('next.owl.carousel', [300]);
                return false;
            });

        });
    };
};

HL.owl.opacityFull = function opacityFull() {
    const owlSettings = {
        items: 1,
        loop: false,
        dots: true,
        nav: false,
        animateOut: 'fadeOut',
        animateIn: 'emptyClass',

        smartSpeed: 450,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: false,
        lazyLoad:true,
        mouseDrag: true,
        touchDrag: true
    };

    let owlOpacitySlider = $('.js-owl-opacity');

    if ( owlOpacitySlider.length ) {

        owlOpacitySlider.each(function(index) {
            var self = this,
                owl = $(self),
                dotsDefault,
                dotsWithArrows,
                sliderWrapper,
                isLazy,
                isWorking = false;

            dotsDefault = owl.attr( 'data-dots-default' );
            dotsWithArrows = owl.attr( 'data-dots-with-arrows' );
            isLazy = (owl.attr('data-lazy') ? owl.attr('data-lazy') == 'true' : true);
            sliderWrapper = owl.parent();

            owlSettings.lazyLoad = isLazy;

            if ( dotsDefault !== 'true' ) {
                owlSettings.dotsContainer = `#${owl.parent().attr('id')} .owl-carousel__dots-wrapper`;
                owl.owlCarousel(owlSettings);
                owl.trigger('stop.owl.autoplay');

                $( '<a href="" class="owl-next" type="button"> <svg xmlns="http://www.w3.org/2000/svg" width="17.968" height="18" viewBox="0 0 17.968 18">   <path d="M630.861,3701.64l-8.6-8.64-0.713.72,7.735,7.77H613.049v1.02h16.236l-7.735,7.77,0.713,0.72,8.6-8.64A0.512,0.512,0,0,0,630.861,3701.64Z" transform="translate(-613.063 -3693)"/> </svg></a>' ).insertAfter( owl.parent().find('.owl-carousel__dots-wrapper') );

                owl.parent().find('.owl-next').click(function() {
                    if (!isWorking) {
                        owl.trigger('next.owl.carousel', [300]);
                    }
                    return false;
                });

                owl.find('.owl-carousel__dots-wrapper .owl-dot').click(function(e) {
                    if (isWorking) {
                        e.stopPropagation();
                    }
                });

            } else {
                owlSettings.dotsContainer = false;
                owl.owlCarousel(owlSettings);
                owl.trigger('stop.owl.autoplay')
            }


            if ( dotsWithArrows === 'true' ) {
                $( '<a href="" class="owl-prev" type="button"> <svg xmlns="http://www.w3.org/2000/svg" width="17.969" height="18" viewBox="0 0 17.969 18">   <path stroke="#ffffff" d="M370.171,3702.36l8.612,8.64,0.715-.72-7.749-7.77h16.265v-1.02H371.749l7.749-7.77-0.715-.72-8.612,8.64A0.511,0.511,0,0,0,370.171,3702.36Z" transform="translate(-370.031 -3693)"/> </svg></a>' ).insertBefore( owl.find('.owl-dots') );
                $( '<a href="" class="owl-next" type="button"> <svg xmlns="http://www.w3.org/2000/svg" width="17.968" height="18" viewBox="0 0 17.968 18">   <path stroke="#ffffff" d="M630.861,3701.64l-8.6-8.64-0.713.72,7.735,7.77H613.049v1.02h16.236l-7.735,7.77,0.713,0.72,8.6-8.64A0.512,0.512,0,0,0,630.861,3701.64Z" transform="translate(-613.063 -3693)"/> </svg></a>' ).insertAfter( owl.find('.owl-dots') );

                owl.find('.owl-prev').click(function() {
                    if (!isWorking) {
                        owl.trigger('prev.owl.carousel', [300]);
                    }
                    return false;
                });

                owl.find('.owl-next').click(function() {
                    if (!isWorking) {
                        owl.trigger('next.owl.carousel', [300]);
                    }
                    return false;
                });

                owl.find('.owl-dots .owl-dot').click(function(e) {
                    if (isWorking) {
                        e.stopPropagation();
                    }
                });
            }


            if (sliderWrapper.find('.js-circle-nav')) {
                sliderWrapper.find('.js-circle-nav').click(function(e) {
                    if (!isWorking) {
                        owl.trigger('to.owl.carousel', e.target.getAttribute('data-slide'));
                        sliderWrapper.find('.js-circle-nav').removeClass('active');
                        $(this).addClass('active');
                    }
                    return false;
                });
            }


            owl.on(
                'translate.owl.carousel',
                function(e) {
                    sliderWrapper.find('.js-circle-nav').removeClass('active');
                    sliderWrapper.find('.js-circle-nav').eq( e.page.index + 1 ).addClass('active');

                    isWorking = true;
                }
            );

            owl.on(
                'translated.owl.carousel',
                function(e) {
                    isWorking = false;
                }
            );

        });
    }
};

HL.owl.owlText = function owlText() {
    const owlSettings = {
        items:1,
        loop: true,
        dots: true,
        nav: false,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        smartSpeed:450,
        mouseDrag: true,
        touchDrag: true,
        autoHeight: true
    };

    let owlSlider = $('.js-owl-text');

    if ( owlSlider.length ) {

        owlSlider.each(function(index) {
            var self = this,
                owl = $(self),
                isWorking = false;

            owl.owlCarousel(owlSettings);

            $( '<a href="" class="owl-next" type="button"> <svg xmlns="http://www.w3.org/2000/svg" width="17.968" height="18" viewBox="0 0 17.968 18">   <path d="M630.861,3701.64l-8.6-8.64-0.713.72,7.735,7.77H613.049v1.02h16.236l-7.735,7.77,0.713,0.72,8.6-8.64A0.512,0.512,0,0,0,630.861,3701.64Z" transform="translate(-613.063 -3693)"/> </svg></a>' ).insertAfter( owl.find('.owl-dots') );

            owl.find('.owl-next').click(function() {
                if (!isWorking) {
                    owl.trigger('next.owl.carousel', [300]);
                }
                return false;
            });

            owl.find('.owl-dots .owl-dot').click(function(e) {
                if (isWorking) {
                    e.stopPropagation();
                }
            });

            owl.on(
                'translate.owl.carousel',
                function(e) {
                    isWorking = true;
                }
            );

            owl.on(
                'translated.owl.carousel',
                function(e) {
                    isWorking = false;
                }
            );
        });
    }
};

HL.owl.slider = function slider() {
    const owlSettingsText = {
        items:1,
        loop: false,
        dots: true,
        nav: false,
        smartSpeed:450,
        mouseDrag: false,
        touchDrag: false,
        animateOut: 'owlFadeOutLeft',
        animateIn: 'owlFadeInLeft'
    };

    const owlSettingsGallery = {
        items:1,
        loop: false,
        dots: false,
        nav: false,
        smartSpeed: 450,
        animateOut: 'fadeOut',
        animateIn: 'fadeIn',
        mouseDrag: true,
        touchDrag: true,
        margin: 10,

        // autoplay: true,
        // autoplayTimeout: 5000,
        // autoplayHoverPause: false
    };

    let owlSlider = $('.js-owl-slider');

    if ( owlSlider.length ) {

        owlSlider.each(function(index) {
            var self = this,
                wrapper = $(self),
                dotsDefault,
                textSlider,
                gallerySlider,
                isWorking = false,
                counterTransitions = 0,
                counterTextOwl = 0;

            textSlider = wrapper.find('.js-owl-slider-text');
            gallerySlider = wrapper.find('.js-owl-slider-gallery');

            if (textSlider.length > 0) {
                owlSettingsText.dots = false;
                owlSettingsGallery.dots = true;
                owlSettingsGallery.dotsContainer = `#${wrapper.attr('id')} .owl-carousel__dots-wrapper`;
            } else {
                owlSettingsGallery.dots = true;
                owlSettingsGallery.dotsContainer = '';
            }

            textSlider.owlCarousel(owlSettingsText);
            gallerySlider.owlCarousel(owlSettingsGallery);
            gallerySlider.trigger('stop.owl.autoplay');

            if (textSlider.length > 0) {

                if(textSlider.hasClass('bg-black')) {
                    $( '<a href="" class="owl-next" type="button"> <svg xmlns="http://www.w3.org/2000/svg" width="17.968" height="18" viewBox="0 0 17.968 18" fill="white">   <path d="M630.861,3701.64l-8.6-8.64-0.713.72,7.735,7.77H613.049v1.02h16.236l-7.735,7.77,0.713,0.72,8.6-8.64A0.512,0.512,0,0,0,630.861,3701.64Z" transform="translate(-613.063 -3693)"/> </svg></a>' ).insertAfter( wrapper.find('.owl-carousel__dots-wrapper') );
                } else {
                    $( '<a href="" class="owl-next" type="button"> <svg xmlns="http://www.w3.org/2000/svg" width="17.968" height="18" viewBox="0 0 17.968 18" fill="white">   <path d="M630.861,3701.64l-8.6-8.64-0.713.72,7.735,7.77H613.049v1.02h16.236l-7.735,7.77,0.713,0.72,8.6-8.64A0.512,0.512,0,0,0,630.861,3701.64Z" transform="translate(-613.063 -3693)"/> </svg></a>' ).insertAfter( wrapper.find('.owl-carousel__dots-wrapper') );
                }

                if(textSlider.hasClass('bg-black')) {
                    $( '<a href="" class="owl-prev" type="button"> <svg xmlns="http://www.w3.org/2000/svg" width="17.968" height="18" viewBox="0 0 17.968 18" style="transform: rotate(180deg);" fill="white">   <path d="M630.861,3701.64l-8.6-8.64-0.713.72,7.735,7.77H613.049v1.02h16.236l-7.735,7.77,0.713,0.72,8.6-8.64A0.512,0.512,0,0,0,630.861,3701.64Z" transform="translate(-613.063 -3693)"/> </svg></a>' ).insertBefore( wrapper.find('.owl-carousel__dots-wrapper') );
                } else {
                    $( '<a href="" class="owl-prev" type="button"> <svg xmlns="http://www.w3.org/2000/svg" width="17.968" height="18" viewBox="0 0 17.968 18" style="transform: rotate(180deg);" fill="white">   <path d="M630.861,3701.64l-8.6-8.64-0.713.72,7.735,7.77H613.049v1.02h16.236l-7.735,7.77,0.713,0.72,8.6-8.64A0.512,0.512,0,0,0,630.861,3701.64Z" transform="translate(-613.063 -3693)"/> </svg></a>' ).insertBefore( wrapper.find('.owl-carousel__dots-wrapper') );
                }

            }

            wrapper.find('.owl-prev').click(function() {
                if (!isWorking) {
                    if (textSlider.length) {
                        counterTextOwl = 1;
                        textSlider.trigger('prev.owl.carousel', [1000]);
                        gallerySlider.trigger('prev.owl.carousel', [1000]);
                    } else {
                        gallerySlider.trigger('prev.owl.carousel', [1000]);
                    }
                }
                return false;
            });

            wrapper.find('.owl-next').click(function() {
                if (!isWorking) {
                    if (textSlider.length) {
                        counterTextOwl = 1;
                        textSlider.trigger('next.owl.carousel', [1000]);
                        gallerySlider.trigger('next.owl.carousel', [1000]);
                    } else {
                        gallerySlider.trigger('next.owl.carousel', [1000]);
                    }
                }
                return false;
            });

            wrapper.find('.owl-carousel__dots-wrapper .owl-dot').click(function(e) {
                if (isWorking) {
                    e.stopPropagation();
                }
            });

            gallerySlider.on('change.owl.carousel', function(event) {
                if (event.namespace && event.property.name === 'position') {
                  var target = event.relatedTarget.relative(event.property.value, true);
                  textSlider.owlCarousel('to', target, 300, true);
                }
              })

            gallerySlider.on(
                'translate.owl.carousel',
                function(e) {
                    isWorking = true;
                    counterTransitions = 0;
                }
            );

            if (textSlider.length) {
                textSlider.on(
                    'translated.owl.carousel',
                    function(e) {
                        counterTransitions++;
                        if (counterTransitions > 1) {
                            isWorking = false;
                        }
                    }
                );
            } else {
                gallerySlider.on(
                    'translated.owl.carousel',
                    function(e) {
                        isWorking = false;
                    }
                );
            }
        });
    }
};


HL.owl.doubleLayer = function doubleLayer() {
    const autoplaytimeout = 10000;

    const owlSettings = {
        items:1,
        loop: false,
        dots: false,
        nav: false,
        smartSpeed: 3000,
        autoplay: true,
        autoplayTimeout: autoplaytimeout,
        autoplayHoverPause: false,
        mouseDrag: false,
        touchDrag: false
    };

    const owlSettingsMask = {
        items:1,
        loop: false,
        dots: false,
        nav: false,
        smartSpeed: 3000,
        autoplay: false,
        mouseDrag: false,
        touchDrag: false
    };

    let owlSlider = $('.js-owl-double');

    if ( owlSlider.length ) {
        owlSlider.each(function(index) {
            var self = this,
                owl = $(self),
                bgSlider,
                maskSlider,
                initializeCounter = 0,
                animationIn,
                animationOut;

            bgSlider = owl.find('.js-owl-double-bg');
            maskSlider = owl.find('.js-owl-double-mask');

            // initialized.owl.carousel
            owl.on('initialize.owl.carousel',
                function(e) {

                    if (initializeCounter === 0) {

                        setTimeout(function() {
                            $('.js-slider-banner').addClass('animation-in');
                        }, 1000);

                        setTimeout(function() {
                            $('.js-slider-banner').removeClass('animation-in').addClass('animation-out');
                        }, autoplaytimeout - 2000);
                    }
            });

            bgSlider.owlCarousel(owlSettings);
            maskSlider.owlCarousel(owlSettingsMask);

            bgSlider.on(
                'changed.owl.carousel',
                    function(e) {
                        maskSlider.trigger('next.owl.carousel', [3000]);

                        animationIn = setTimeout(function() {
                            $('.js-slider-banner').removeClass('animation-out').addClass('animation-in');
                        }, 3000);

                        animationOut = setTimeout(function() {
                            $('.js-slider-banner').removeClass('animation-in').addClass('animation-out');
                        }, autoplaytimeout - 1500);
                    }
                );

            bgSlider.on(
                'resized.owl.carousel',
                    function(e) {
                        initializeCounter++;

                        clearTimeout(animationIn);
                        clearTimeout(animationOut);

                        maskSlider.trigger('destroy.owl.carousel');
                        bgSlider.trigger('destroy.owl.carousel');

                        bgSlider.owlCarousel(owlSettings);
                        maskSlider.owlCarousel(owlSettingsMask);
                    }
                );

        });
    }
};

HL.contact = {
    loadScript: function() {
        if (!googleMapLoaded) {
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = 'https://maps.googleapis.com/maps/api/js?v=3&key=AIzaSyDuBpemoK57hRMUL6nYmO7gqercpotTOvg&' +
                    'callback=HL.contact.map';
            document.body.appendChild(script);
            googleMapLoaded = true;
        } else {
            HL.contact.map();
        }
    },

    map: function() {
        function init() {
                var draggable;
                var isMobile = function() {
                try{ document.createEvent("TouchEvent"); return true; }
                    catch(e){ return false; }
                };
                if(isMobile()) {
                    draggable = false;
                } else {
                    draggable = true;
                }

                var maps = document.querySelectorAll('.js-map');

                [].forEach.call(maps, function(mapObj) {

                    var myLatLngX = mapObj.getAttribute('data-latitude');
                    var myLatLngY = mapObj.getAttribute('data-longitude');

                    var mapOptions = {
                        zoom: 15,
                        center: new google.maps.LatLng(myLatLngX,myLatLngY),
                        scrollwheel: false,
                        draggable: draggable,

                        zoomControl: true,
                        zoomControlOptions: {
                            style: google.maps.ZoomControlStyle.LARGE,
                            position: google.maps.ControlPosition.RIGHT_TOP
                        },
                        styles: [{"featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{"color": "#444444"}]},{"featureType": "landscape", "elementType": "all", "stylers": [{"color": "#f2f2f2"}]},{"featureType": "landscape", "elementType": "geometry.fill", "stylers": [{"visibility": "on"},{"hue": "#ff0000"}]},{"featureType": "landscape.man_made", "elementType": "geometry", "stylers": [{"lightness": "100"}]},{"featureType": "landscape.man_made", "elementType": "labels", "stylers": [{"visibility": "off"}]},{"featureType": "landscape.natural", "elementType": "geometry.fill", "stylers": [{"lightness": "100"}]},{"featureType": "landscape.natural", "elementType": "labels", "stylers": [{"visibility": "off"}]},{"featureType": "landscape.natural.landcover", "elementType": "geometry.fill", "stylers": [{"visibility": "on"}]},{"featureType": "landscape.natural.terrain", "elementType": "geometry", "stylers": [{"lightness": "100"}]},{"featureType": "landscape.natural.terrain", "elementType": "geometry.fill", "stylers": [{"visibility": "off"},{"lightness": "23"}]},{"featureType": "poi", "elementType": "all", "stylers": [{"visibility": "off"}]},{"featureType": "road", "elementType": "all", "stylers": [{"saturation": -100},{"lightness": 45}]},{"featureType": "road.highway", "elementType": "all", "stylers": [{"visibility": "simplified"}]},{"featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{"color": "#ffd900"}]},{"featureType": "road.arterial", "elementType": "labels.icon", "stylers": [{"visibility": "off"}]},{"featureType": "transit", "elementType": "all", "stylers": [{"visibility": "off"}]},{"featureType": "water", "elementType": "all", "stylers": [{"color": "#ffd900"},{"visibility": "on"}]},{"featureType": "water", "elementType": "geometry.fill", "stylers": [{"visibility": "on"},{"color": "#cccccc"}]},{"featureType": "water", "elementType": "labels", "stylers": [{"visibility": "off"}]}]
                    };

                    var mapElement = mapObj;
                    var map = new google.maps.Map(mapElement, mapOptions);
                    var image = static_folder+'/map-marker.png';
                    var marker = new google.maps.Marker({
                        position: map.getCenter(),
                        icon: image,
                        map: map,
                        animation: google.maps.Animation.DROP,
                        url: 'http://maps.google.com/?q='+myLatLngX+','+myLatLngY
                    });

                    google.maps.event.addDomListener(window, 'resize', function() {
                        var center = map.getCenter();
                        google.maps.event.trigger(map, 'resize');
                        map.setCenter(center);
                    });
                });
        }
        init();
    }
};

HL.utils.infiniteCallback = function infiniteCallback() {
    HL.utils._animationedSections();
    HL.refreshLazyLoading();
};

HL.utils.loadScript = (src, callback) => {
    let s, r, t;
  
    r = false;
    s = document.createElement('script');
    s.type = 'text/javascript';
    s.src = src;
    s.onload = s.onreadystatechange = function() {
      if ( !r && (!this.readyState || this.readyState == 'complete') ) {
        r = true;

        if (callback) {
          callback();
        }
      }
    };
    t = document.getElementsByTagName('script')[0];
    t.parentNode.insertBefore(s, t);
};

HL.selectReveal = function selectReveal() {
    let select = document.querySelector('.js-reveal-input');

    if (select) {
        console.log('init');
    
        select.addEventListener('change', function() {
            let revealRow = document.querySelector('.js-reveal-row');
            
            if (select.value == "Other") {
                revealRow.classList.remove('hidden');
            } else if (!revealRow.classList.contains('hidden')) {
                revealRow.classList.add('hidden');
            }
        })
    }
};

HL.utils.setCookie = function({name, val, days}) {
    var expires;

    if (days) {
        var data = new Date();
        data.setTime(data.getTime() + (days * 24*60*60*1000));
        expires = "; expires="+data.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = name + "=" + val + expires + "; path=/";
};

HL.utils.isCookieSet = function({name}) {
    if (document.cookie!=='') {
        var cookies=document.cookie.split("; ");

        for (var i=0; i<cookies.length; i++) {
            var cookieName=cookies[i].split("=")[0];
            var cookieVal=cookies[i].split("=")[1];

            if (cookieName === name) {
                return decodeURI(cookieVal);
            }
        }
    }
}

// Cookie
HL.cookieNotification = {
    cookieName: 'cookieNotification',
    button: document.querySelector('.js-cookie-btn'),
    layer: document.querySelector('.js-cookie'),
    show: function() {

        if (!(HL.utils.isCookieSet( {name: this.cookieName } ))) {
            this.layer.classList.add('cookie--show');
        }
    },
    save: function() {
        HL.utils.setCookie({
            name: this.cookieName, 
            val: true, 
            days: 30 
        });
        this.layer.classList.remove('cookie--show');
        return false;
    },
    init: function() {
        if (this.layer) {
            this.show();
        }
    }
};

HL.button = function button() {
    let allBtns = document.querySelectorAll(".btn");

    if (allBtns) {
        [].forEach.call(allBtns, function(btn) {
            let btnText = btn.innerHTML;

            if(btn.classList.contains('btn--icon')){

                btn.innerHTML = (`
                    <span>${btnText}</span>
                    <svg width="18px" height="18px" class="btn__icon"><use xlink:href="/images/icons.svg#icon-arrow-down"/></svg>
                `);
            } else {
                btn.innerHTML = (`
                    <span>${btnText}</span>
                `);
            }
        });
    }
};


HL.refreshLazyLoading = function() {
    if (window['lazyLoadInstance'] !== undefined) {
        lazyLoadInstance.update();
    }
};

window.addEventListener('resize', function() {
    setTimeout(function(){
        HL.utils.videoFit();
        Waypoint.refreshAll();
    }, 80);

}, false);

window.addEventListener('scroll', function() {
    HL.navigation.navbarPosition();
}, false);

function runWebsiteScripts() {
    HL.owl.gallery();
    HL.owl.opacityFull();
    HL.owl.owlText();
    HL.owl.doubleLayer();
    HL.navigation.init();
    HL.utils.videoFit();
    HL.utils.infiniteScroll(HL.utils.infiniteCallback);

    HL.cookieNotification.init();
    

    $('.l-header.bg-img').bgLoaded({
        afterLoaded : function(){
            this.addClass('bg-loaded');
            HL.utils._animationedSections();
            Waypoint.refreshAll();
        }
    });

    HL.utils.hashAnchorClick();
    HL.utils._openPopupOnClick();
    HL.utils._magnific();
    HL.utils.inputLabels();
    HL.utils._animationedSections();
    HL.selectReveal();
    //HL.button();
    HL.instagramFeed.init();

    setTimeout(function() {
        HL.utils.videoFit();
        HL.owl.slider();
        Waypoint.refreshAll();
    }, 0);

    HL.refreshLazyLoading();

    if ($('.js-map').length) {
        const mapWaypoint = new Waypoint({
            element: $('.js-map')[0],
            handler: function(direction) {
                if (direction === 'down') {
                    HL.contact.loadScript();
                }
            },
            offset: '80%'
        });
    }

    $(window).on('load', function() {
        HL.owl.process();
    });
}

function trackPageGTM({ isFirstVisit = false }) {
    if (window['dataLayer'] === undefined) {
        return;
    }

    if (isFirstVisit) {
        window.dataLayer.push({
            originalLocation: document.location.protocol + '//' +
                              document.location.hostname +
                              document.location.pathname +
                              document.location.search
          });
    }

    let url = window.location.pathname + window.location.search;

    window.dataLayer.push({
        event: 'page-visit',
        url
    });
}

/*
 * -----------------------------------------------------------
 * // Dynamic loading via Barba.js and its settings start here
 *
*/
const FadeTransition = Barba.BaseTransition.extend({
  start: function() {
    Promise
      .all([this.fadeOut(), this.newContainerLoading])
      .then(this.fadeIn.bind(this));
  },

  fadeOut: function() {
    var deferred = new jQuery.Deferred();
    let menuWasOpened = false;
    let fadeOutTimeout = 0;
    const burgerMenuButton = document.querySelector('.js-burger');

    if (burgerMenuButton && burgerMenuButton.classList.contains('l-burger--open')) {
        burgerMenuButton.click();
        menuWasOpened = true;
    }

    if (HL.utils._screenSize().x > 577 && menuWasOpened) {
        fadeOutTimeout = 500;
        document.body.classList.remove('open');
    }

    Waypoint.destroyAll();

    setTimeout(function() {
        deferred.resolve();
    }, fadeOutTimeout);

    return deferred.promise().then(() => {
        return $(this.oldContainer).animate({ opacity: 0 }, 400).promise();
    });
  },

  fadeIn: function() {
    function destroyOwlCarousels() {
        if (!($('.owl-loaded').length)) {
            return;
        }

        $('.owl-loaded').trigger('destroy.owl.carousel').removeClass('owl-carousel owl-loaded');
        $('.owl-loaded').find('.owl-stage-outer').children().unwrap();
    }

    $(window).scrollTop(0); // scroll to top here
    destroyOwlCarousels();

    var _this = this;
    var $el = $(this.newContainer);

    $(this.oldContainer).hide();

    $el.css({
        visibility : 'visible',
        opacity : 0
    });

    $el.animate({ opacity: 1 }, 200, function() {
        _this.done();
    });
  }
});

Barba.Pjax.getTransition = function() {
  return FadeTransition;
};

Barba.Dispatcher.on('transitionCompleted', function(currentStatus, oldStatus) {
    runWebsiteScripts();
});

let isFirstVisit = true;

Barba.Dispatcher.on('newPageReady', function(current, prev, container) {
    history.scrollRestoration = 'manual';
    trackPageGTM({ isFirstVisit });

    if (isFirstVisit) {
        isFirstVisit = false;
    }
});
/*
 * -----------------------------------------------------------
*/

(function() {
    Barba.Pjax.start();
    Barba.Pjax.getTransition();
    Barba.Prefetch.init();
})();

